var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42593",
    "data-name": "Group 42593",
    transform: "translate(17878 -6577)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15961",
    "data-name": "Rectangle 15961",
    width: 16,
    height: 16,
    transform: "translate(-17878 6577)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M13.823,9.225l-4.2,4.2a.6.6,0,1,1-.848-.848L11.951,9.4H2.6a.6.6,0,0,1,0-1.2h9.351L8.776,5.024a.6.6,0,1,1,.848-.848l4.2,4.2a.6.6,0,0,1,0,.85Z",
    transform: "translate(-17878 6576.2)",
    fill: "#1564e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.3cb894b03b4148888326efd36d1ddba3.svg";
export { ForwardRef as ReactComponent };